/**
 * RegionalTeachersOpenShifts — "Open Shifts" card: upcoming workshops
 * with no teacher assigned (live, op DB), urgency-chipped, with a Fill
 * disabled-CTA until an assignment flow exists.
 */
import type { RegionalTeachersDto } from './regionalApi';

function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

function ShiftRow({ shift }: { shift: RegionalTeachersDto['openShifts'][number] }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '7px 10px',
        background: 'var(--nb-surface)',
        borderRadius: 7,
        border: '1px solid var(--nb-border)',
      }}
    >
      <span className="nb-tabular" style={{ width: 60, fontSize: 11, fontWeight: 600 }}>
        {fmtDate(shift.startsAtIso)}
      </span>
      <span className="nb-muted" style={{ width: 64, fontSize: 11 }}>
        {fmtTime(shift.startsAtIso)}
      </span>
      <span style={{ flex: 1, fontSize: 11.5 }}>
        <strong>{shift.venueShort}</strong>{' '}
        <span style={{ color: 'var(--nb-subtle)' }}>· {shift.role}</span>
      </span>
      {shift.urgent && (
        <span
          style={{
            fontSize: 9.5,
            fontWeight: 700,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            padding: '2px 7px',
            borderRadius: 999,
            background: 'var(--nb-warn-soft)',
            color: 'var(--nb-warn)',
          }}
        >
          Urgent
        </span>
      )}
      <button
        type="button"
        className="nb-btn"
        disabled
        style={{ height: 22, padding: '0 8px', fontSize: 10.5, opacity: 0.55 }}
        title="Coming soon — shift assignment ships with the scheduling write flows"
      >
        Fill
      </button>
    </div>
  );
}

export function RegionalTeachersOpenShifts({
  openShifts,
}: {
  openShifts: RegionalTeachersDto['openShifts'];
}) {
  return (
    <section className="nb-card">
      <div className="nb-card-hd">
        <h3 className="nb-display" style={{ fontSize: 13, letterSpacing: '0.04em', margin: 0 }}>
          Open Shifts
        </h3>
        <span
          className="nb-pill nb-status-soft"
          style={{ height: 18, fontSize: 9.5, padding: '0 6px' }}
        >
          {openShifts.length} to fill
        </span>
      </div>
      {openShifts.length === 0 ? (
        <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
          Every upcoming workshop has a teacher assigned.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {openShifts.map((s) => (
            <ShiftRow key={`${s.startsAtIso}-${s.venueShort}`} shift={s} />
          ))}
        </div>
      )}
    </section>
  );
}
